import React, { useMemo } from "react";

import { Order } from "../../../../../../../services";
import { useAppContext } from "../../../../../../../context";
import { ConstantFormat } from "../../../../../../../utils/DateFns";
import { CellContentRoot } from "..";

const ExecutorArrivalTimeCellContent: React.FC<
	ExecutorArrivalTimeCellContent.Props
> = ({ item }) => {
	const { dateFns } = useAppContext();

	const lastReceivedOrder = useMemo(
		() => item?.additionalFields?.transfer?.lastReceivedOrder,
		[item?.additionalFields?.transfer?.lastReceivedOrder],
	);

	const transferExecutor = useMemo(
		() => lastReceivedOrder?.executorToOrder?.[0],
		[lastReceivedOrder?.executorToOrder],
	);

	const mainExecutor = useMemo(
		() => item.executorToOrder?.[0],
		[item.executorToOrder],
	);

	const mainArrivalTime = useMemo(
		() => mainExecutor?.additionalFields?.arrivalTime,
		[mainExecutor?.additionalFields?.arrivalTime],
	);

	const transferArrivalTime = useMemo(
		() => transferExecutor?.additionalFields?.arrivalTime,
		[transferExecutor?.additionalFields?.arrivalTime],
	);

	const arrivalTime = useMemo(
		() => mainArrivalTime || transferArrivalTime,
		[mainArrivalTime, transferArrivalTime],
	);

	const time = useMemo(
		() =>
			item?.orderDate ||
			item?.filledAt ||
			lastReceivedOrder?.filledAt ||
			lastReceivedOrder?.orderDate ||
			1,
		[
			lastReceivedOrder?.filledAt,
			lastReceivedOrder?.orderDate,
			item?.filledAt,
			item?.orderDate,
		],
	);

	const content = useMemo(() => {
		const orderTime = dateFns.toZonedTime(time).getTime();
		const value = Math.max(
			orderTime,
			dateFns.toZonedTime(arrivalTime).getTime(),
		);

		return dateFns.formatTime(value, {
			formatTime: ConstantFormat.HMS_UK,
			isZeroSeconds: true,
		});
	}, [dateFns, time, arrivalTime]);

	return (
		<CellContentRoot alignItems="center" h="100%" w="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace ExecutorArrivalTimeCellContent {
	interface Props {
		item: Order.Model;
	}
}

export default ExecutorArrivalTimeCellContent;
